module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Minus_16"],"rect":[{"$":{"x":"3","y":"7","width":"10","height":"2","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Minus_16.svg
// module id = uYdA
// module chunks = 1